import { jsx as l } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as r } from "zod";
import { withZod as a } from "@made-people/react-prop-guard";
import { scrollWrapperBlueprint as i } from "./index-blueprint.es.js";
import c from "clsx";
import "@made-people/blueprint";
const e = r.object({
  variants: r.custom().optional(),
  children: r.custom().optional(),
  className: r.string().optional()
}), x = m(
  "ScrollWrapper",
  a(e, ({ variants: o, className: t, children: p }) => {
    const s = i.styles(o);
    return /* @__PURE__ */ l("div", { className: c(t, s.wrapper), children: p });
  })
);
export {
  x as ScrollWrapper,
  e as scrollWrapperSchema
};
//# sourceMappingURL=index.es.js.map
